import { opacity, spacing } from '@lamimed/pantheon';
import { Scroll } from 'lucide-react';
import styled, { css } from 'styled-components';

import { Variant } from '.';

interface ContainerProps {
  variant?: Variant;
}

export const Container = styled.div<ContainerProps>`
  ${({ variant }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    opacity: ${opacity.medium};
    height: ${variant === 'nomore' ? 'auto' : '100%'};
  `}
`;

export const ScrollIcon = styled(Scroll)`
  margin-bottom: ${spacing.small};
`;
